import axios from 'axios';
import API_BASE_URL from '../Config'; 

// 🔧 Función auxiliar para convertir productos a Map<Long, Integer>
function convertirProductosAVistaMap(productos) {
  const map = {};
  productos.forEach(p => {
    //map[p.id] = p.cantidad;
    map[parseInt(p.id)] = p.cantidad;
  });
  return map;
}

// 🔧 Función auxiliar para calcular montos de IVA
async function calcularMontosIVA(productosConCantidad) {
  try {
    const productosMap = convertirProductosAVistaMap(productosConCantidad);

    const response = await fetch(`${API_BASE_URL}/api/iva/vista-detalle`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(productosMap),
    });

    if (!response.ok) throw new Error("Error al calcular IVA");

    const detalle = await response.json();

    let exenta = 0;
    let gravada_5 = 0;
    let gravada_10 = 0;
    let liquidacion_5 = 0;
    let liquidacion_10 = 0;

    detalle.forEach((item) => {
      const tipo = item.tipoIva || "EXENTO";;
      const subtotal = item.subtotal;
      const ivaUnitario = item.ivaUnitario || 0;
      const cantidad = item.cantidad || 1;
      const totalIva = ivaUnitario * cantidad;

      if (!tipo || tipo === "EXENTO") {
        exenta += subtotal;
      } else if (tipo === "IVA_5") {
        gravada_5 += item.precioSinIva * cantidad;
        liquidacion_5 += totalIva;
      } else if (tipo === "IVA_10") {
        gravada_10 += item.precioSinIva * cantidad;
        liquidacion_10 += totalIva;
      }
    });

    const total_iva = liquidacion_5 + liquidacion_10;

    return {
      exenta: Number(exenta.toFixed(2)),
      gravada_5: Number(gravada_5.toFixed(2)),
      gravada_10: Number(gravada_10.toFixed(2)),
      liquidacion_5: Number(liquidacion_5.toFixed(2)),
      liquidacion_10: Number(liquidacion_10.toFixed(2)),
      total_iva: Number(total_iva.toFixed(2)),
    };
  } catch (err) {
    console.error("Error al calcular montos IVA:", err);
    return {
      exenta: 0,
      gravada_5: 0,
      gravada_10: 0,
      liquidacion_5: 0,
      liquidacion_10: 0,
      total_iva: 0,
    };
  }
}

export async function enviarVentaYPropina(ventaTemp) {
  try {
    // 1. Guardar propina si existe
    let propinaId = null;
    if (ventaTemp.propina > 0 && ventaTemp.mozo) {
      const propinaRes = await axios.post(`${API_BASE_URL}/api/propinas`, {
        monto: ventaTemp.propina,
        mozo: ventaTemp.mozo,
        fecha: new Date().toISOString(),
        estado: false,
        descuento: ventaTemp.descuento || 0
      });
      propinaId = propinaRes.data.id;
    }

    // 2. Calcular los montos de IVA usando los productos
    const ivaMontos = await calcularMontosIVA(ventaTemp.productos);

    // 3. Preparar los datos de productos
    const productosVendidos = convertirProductosAVistaMap(ventaTemp.productos);

    const productosInfo = ventaTemp.productos.map(p => ({
      id: p.id,
      nombre: p.nombre,
      cantidad: p.cantidad,
      precio: p.precio
    }));

    await console.log("📦 Datos que se enviarán:", {
      productosVendidos,
      productosInfo,
      metodoPago: ventaTemp.metodoPago,
      propinaId,
      propina: ventaTemp.propina,
      exenta: ventaTemp.exenta,
      descuentoTotal: ventaTemp.descuento,
      registerProcess: ventaTemp.cliente?.ci
    });

    const ventaResponse = await axios.post(`${API_BASE_URL}/api/ventas`, {
      productosVendidos,
      productosInfo,
      metodoPago: ventaTemp.metodoPago || 'EFECTIVO',
      propinaId: propinaId,
      propina: ventaTemp.propina || 0,
      exenta: ventaTemp.exenta || 0,
      descuentoTotal: ventaTemp.descuento || 0,
      registerProcess: ventaTemp.cliente?.ci || null
    });

    console.log('✅ Datos enviados correctamente con IVA y productos completos.');

    // Retornar el objeto original + el ID de la venta
    return {
      ventaTemp,
      id: ventaResponse?.data?.id || null
    };

  } catch (error) {
    console.error('❌ Error al enviar datos:', error);
    return {
      ventaTemp,
      id: null
    };
  }
}

export const login = async (username, password) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/auth/login`, {
      username,
      password
    });
    return response.data.token;
  } catch (error) {
    console.error('Error de login:', error.response?.data || error.message);
    throw error;
  }
};
